import { Franchise, FeeValue } from '@/types';
import { Typography } from 'antd';

// TCX-866: each leaf is now { type, value, note } instead of a bare scalar
// (previously number/string). Callers pass franchise.commissions or
// franchise.internationalCommissions straight through, so this local shape
// must track the Franchise type.
interface Props {
  commissions?: {
    singleUnit?: FeeValue;
    multipleUnit?: FeeValue;
    areaMaster?: FeeValue;
    veteran?: FeeValue;
    resale?: FeeValue;
  };
}

export default function FranchisorCommissionsAdminSections({
  commissions,
}: Props) {
  return (
    <div className="details-section-column">
      <div className={'details-section-line'}>
        <Typography.Text className="general-info-text">
          Flat Fee USD or %
        </Typography.Text>
        <Typography.Text className="general-info-value">
          {/* TCX-866: unwrap .value for display; type affix/note is TCX-867/868. */}
          {commissions?.singleUnit?.value ? commissions.singleUnit.value : '-'}
        </Typography.Text>
      </div>
      <div className={'details-section-line'}>
        <Typography.Text className="general-info-text">
          Veteran (USD)
        </Typography.Text>
        <Typography.Text className="general-info-value">
          {/* TCX-866: unwrap .value for display; type affix/note is TCX-867/868. */}
          {commissions?.veteran?.value ? commissions.veteran.value : '-'}
        </Typography.Text>
      </div>
      <div className={'details-section-line'}>
        <Typography.Text className="general-info-text">
          Area/Master (USD)
        </Typography.Text>
        <Typography.Text className="general-info-value">
          {/* TCX-866: unwrap .value for display; type affix/note is TCX-867/868. */}
          {commissions?.areaMaster?.value ? commissions.areaMaster.value : '-'}
        </Typography.Text>
      </div>
      <div className={'details-section-line'}>
        <Typography.Text className="general-info-text">Resale</Typography.Text>
        <Typography.Text className="general-info-value">
          {/* TCX-866: unwrap .value for display; type affix/note is TCX-867/868. */}
          {commissions?.resale?.value ? commissions.resale.value : '-'}
        </Typography.Text>
      </div>
      <div className={'details-section-column'}>
        <Typography.Text className="general-info-text">
          Multiple Unit
        </Typography.Text>
        <Typography.Text className="general-info-value">
          {/* TCX-866: unwrap .value for display; type affix/note is TCX-867/868. */}
          {commissions?.multipleUnit?.value ? commissions.multipleUnit.value : '-'}
        </Typography.Text>
      </div>
    </div>
  );
}
